import { Component, Input, OnInit } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { HttpService } from "../../../../core";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: 'agencies-log',
    templateUrl: './agencies-log.html',
    styleUrls: ['./agencies-log.scss']
})
export class AgenciesLog implements OnInit {
    SERVER_URL = environment.SERVER_URL;

    @Input() logData: any
    @Input() projectId: number

    VERIFICATION_CODE_URL = environment.VERIFICATION_CODE_URL;

    content: any[] = [];
    pageIndex: number = 0;
    pageSize: number = 25;
    length: number;
    totalElements: number;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];
    fileNames: string[] = [];

    tableIndex: number = -1;

    logDetail = {
        commissionSetting: null,
        log: null
    }

    commissionStageSetting: any[] = []

    oneStage = {
        activeValue: null,
        activeType: null
    }

    twoStage = {
        activeValue: null,
        activeType: null
    }

    threeStage = {
        activeValue: null,
        activeType: null
    }

    name: string;
    status: string;

    selected = 'all';

    constructor(private httpService: HttpService,
        private dialog: MatDialog,) {
    }

    ngOnInit() {
        console.log(this.logData)
        this.content = this.logData.data.content
        this.length = this.logData.data.totalElements
        this.pageIndex = this.logData.data.number;
        this.pageSize = this.logData.data.size;
        this.totalElements = this.logData.data.totalElements;
    }

    setLogData(res) {
        this.content = res.data.content
        this.length = res.data.totalElements
        this.pageIndex = res.data.number;
        this.pageSize = res.data.size;
        this.totalElements = res.data.totalElements;
    }

    open(item, i) {
        if (i == this.tableIndex) {
            this.tableIndex = -1
        } else {
            this.tableIndex = i
        }
    }

    getSalesByPage(pageSize, e) {
        this.httpService.pagedListProjectApplicationLogs(this.projectId, {
            name: this.name,
            status: this.status == 'all' ? null : this.status,
            page: e.pageIndex,
            pageSize: e.pageSize
        }).toPromise().then((res: any) => {
            console.log(res.content);
            this.setLogData(res)
        });
    }

    getLogDetail(item) {
        this.fileNames = []
        this.httpService.getApproveLogDetail(item.id).toPromise().then((res: any) => {
            this.logDetail = res.data
            if (res.data.log.fileName) {
                this.fileNames = res.data.log.fileName.split(',');
            }
            if (this.logDetail.commissionSetting) {
                this.commissionStageSetting = this.logDetail.commissionSetting.stageSettingList
                this.commissionStageSetting.forEach(item => {
                    if (item.step == 0) {
                        this.oneStage = item
                    }
                    if (item.step == 1) {
                        this.twoStage = item
                    }
                    if (item.step == 2) {
                        this.threeStage = item
                    }
                })
            }
        })
    }

    searchLogList() {
        this.httpService.pagedListProjectApplicationLogs(this.projectId, {
            name: this.name,
            status: this.status == 'all' ? null : this.status,
            page: this.pageIndex,
            pageSize: this.pageSize
        }).toPromise().then((res: any) => {
            console.log(res.content);
            this.setLogData(res)
        });
    }

    test(event, item) {
        event.stopPropagation()
        event.preventDefault()
    }

    previewApplyFile(file, logDetail) {
        window.open(this.VERIFICATION_CODE_URL + 'files/' + logDetail.log.applicationId + '/application/' + file);
    }
}
